export const Band = [
  { id: 1, Name: 'Band 1', sortingOrder: 1, key: 'Band 1' },
  { id: 2, Name: 'Band 2', sortingOrder: 2, key: 'Band 2' },
  { id: 3, Name: 'Band 3', sortingOrder: 3, key: 'Band 3' },
  { id: 4, Name: 'Band 4', sortingOrder: 4, key: 'Band 4' },
  { id: 5, Name: 'Band 5', sortingOrder: 5, key: 'Band 5' },
  { id: 6, Name: 'Band 6', sortingOrder: 6, key: 'Band 6' },
  { id: 7, Name: 'Band 7', sortingOrder: 7, key: 'Band 7' },
  { id: 8, Name: 'Band 8', sortingOrder: 8, key: 'Band 8' },
  { id: 9, Name: 'Band 8a', sortingOrder: 9, key: 'Band 9' },
  { id: 10, Name: 'Band 8b', sortingOrder: 10, key: 'Band 10' },
  { id: 11, Name: 'Band 8c', sortingOrder: 11, key: 'Band 11' },
  { id: 12, Name: 'Band 8d', sortingOrder: 12, key: 'Band 12' },
];
